import React, { Component, Children } from 'react';
import PropTypes from 'prop-types';

// 참조 https://reactjs.org/docs/composition-vs-inheritance.html#children
// https://reactjs.org/docs/react-api.html#react.children
// composition 방식으로 설계하는것을 추천
function coalesceNonElementChildren(children, coalesceNodes) {
  const coalescedChildren = [];

  let contiguousNonElements = [];
  Children.forEach(children, (child) => {
    if (!React.isValidElement(child)) {
      contiguousNonElements.push(child);
      return;
    }

    if (contiguousNonElements.length) {
      coalescedChildren.push(coalesceNodes(contiguousNonElements, coalescedChildren.length));
      contiguousNonElements = [];
    }

    coalescedChildren.push(child);
  });

  if (contiguousNonElements.length) {
    coalescedChildren.push(coalesceNodes(contiguousNonElements, coalescedChildren.length));
  }

  return coalescedChildren;
}

class DivButton extends Component {
  renderGroupedChildren() {
    const getChildren = coalesceNonElementChildren(this.props.children, (children, index) => (
      <p
        key={index}
      >
        {children}
      </p>
    ));

    switch (getChildren.length) {
      case 0:
        return null;
      case 1:
        return getChildren[0];
      default:
        return getChildren;
    }
  }

  render() {
    return (
      <div
        role="button"
        tabIndex={this.props.tabIndex}
        onClick={() => this.props.onClick()}
        style={{ ...this.props.style, cursor: 'pointer' }}
      >
        {this.renderGroupedChildren()}
      </div>
    );
  }
}

DivButton.propTypes = {
  tabIndex: PropTypes.number,
  onClick: PropTypes.func,
  style: PropTypes.object,
  children: PropTypes.node,
};

DivButton.defaultProps = {
  tabIndex: 0,
  onClick: () => {},
  style: {},
  children: {},
};

export default DivButton;
